import * as types from './types';

export default {
    [types.SET_APPLIED_FILTERS_COUNT](state, count) {
        state.appliedFiltersCount = count;
    },
};